module.exports = __webpack_public_path__ + "prod/1.42.2/img/37.c069d964.svg";